module.exports = __webpack_public_path__ + "static/img/tutorial3_1.401201a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin_dealer/tutorial3_1.png
// module id = AsHk
// module chunks = 0